// src/Components/AIMito/Suggestions.tsx
import React from 'react';
import { QBOIcon } from 'assets/icons';

interface SuggestionsProps {
  suggestions: string[];
  onClick: (suggestion: string) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({ suggestions, onClick }) => (
  <div className="suggestions">
    {suggestions.map((suggestion, index) => {
      const needsQBLogo = /profit and loss|balance sheet|invoice/i.test(
        suggestion,
      );

      return (
        <button
          key={index}
          className={`suggestion-btn${needsQBLogo ? ' suggestion-qb' : ''}`}
          onClick={() => onClick(suggestion)}
        >
          {needsQBLogo && <QBOIcon className="suggestion-qb-icon" />}
          {suggestion}
        </button>
      );
    })}
  </div>
);

export default Suggestions;
